import { IconAdd, IconSubtract } from "@components/svg/Icons"
import { Button } from "./Button"
import { twMerge } from "tailwind-merge"

type Props = {
  value: number
  onValueChange: (value: number) => void
  max?: number
  disabled?: boolean
}

export function QuantitySelector(props: Props) {
  return (
    <div className="flex justify-between items-center">
      <div
        className={twMerge("type-ui-m-light border rounded-full w-1/2 text-center h-button flex items-center justify-center max-w-[150px]", props.disabled && "text-grey-light")}
      >
        {props.value}
      </div>
      <div className="flex gap-1">
        <Button variant="outline" size="square" leftIcon={<IconSubtract />} disabled={props.disabled || props.value <= 0} onClick={() => props.onValueChange(props.value - 1)} />
        <Button
          variant="outline"
          size="square"
          leftIcon={<IconAdd />}
          disabled={props.disabled || (props.max && props.value >= props.max)}
          onClick={() => props.onValueChange(props.value + 1)}
        />
      </div>
    </div>
  )
}
